import {
    IRegistersDetailedMonitoredObject,
    IRegistersMonitoredObject,
} from '../../state/app/registers/monitoredObjects';
import UrlConst from '../../constants/UrlConst';

import { IPage } from '../../state/app/registers/';

import apiClient from '../common/apiClient';
import {
    makeEndpoint,
    makeGetRequestSettings,
    makePutRequestSettings,
} from '../common/utils';

export interface IGetMonitoredObjectsParams {
    name?: string;
    individualForUserId?: number;
}

export type TPutRegistersMonitoredObject = Omit<
    IRegistersDetailedMonitoredObject,
    'group' | 'groups' | 'modifiedAt'
> & {
    groupIds: string[];
};

export const makeMonitoredObjectsUrl = (suffix: string = '', params = {}) => {
    return makeEndpoint(UrlConst.REGISTERS_URL, '/monitored-objects' + suffix, {
        ...params,
    });
};

export const restGetRegistersMonitoredObject = (
    objectId: number
): Promise<IPage<IRegistersMonitoredObject>> =>
    apiClient.send(
        makeGetRequestSettings(makeMonitoredObjectsUrl(`/${objectId}`))
    );

export const restGetRegistersMonitoredObjects = (
    params?: IGetMonitoredObjectsParams
): Promise<IRegistersMonitoredObject[]> =>
    apiClient.send(makeGetRequestSettings(makeMonitoredObjectsUrl('', params)));

export const restPutMonitoredObject = (
    object: TPutRegistersMonitoredObject
): Promise<IRegistersDetailedMonitoredObject> =>
    apiClient.send(
        makePutRequestSettings(makeMonitoredObjectsUrl(`/${object.id}`), object)
    );
